export class DefaultersModel {
  pedidos: PedidosModel[] = new Array<PedidosModel>();
}

export class PedidosModel {
  Id: string;
  Valor: number;
  Date: Date = new Date();
  Produtos: Array<ProdutosModel> = new Array<ProdutosModel>();
  PedidoPodeSerPagoComSaldo: boolean;
  MostraDetalhes: boolean;
  CartaoCashlessId: string;
}

export class ProdutosModel {
  Nome: string;
  Valor: string;
  Quantidade: number;
  ValorTotal: string;
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/defaulters/defaulters.model.ts